import { IntegrationEnum } from '@contracts/api/dto/providers/ProviderDto';
import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const providerListColumns = [
  'provider.id',
  'provider.configs',
  'provider.updatedAt',
  'provider.name',
  'provider.games',
  'provider.configId',
  'provider.apiUrl',
  'provider.syncRoundEnd',
  'provider.status',
  'provider.retryScheduledSendCredit',
  'provider.refundOnCreditFail',
  'provider.filterExternalProviderBets',
  'provider.creditOnDisconnect',
  'provider.isInternal',
  'provider.rgsId',
  'provider.integrationType',
  'provider.createdAt',
] as const;

export type ProviderListColumns = (typeof providerListColumns)[number];

export type ProviderListFilter = {
  'provider.id': string | undefined;
  'provider.configs': string | undefined;
  'provider.updatedAt': string | undefined;
  'provider.name': string | undefined;
  'provider.games': string | undefined;
  'provider.configId': string | undefined;
  'provider.apiUrl': string | undefined;
  'provider.syncRoundEnd': boolean | string | undefined;
  'provider.status': string | undefined;
  'provider.retryScheduledSendCredit': boolean | undefined;
  'provider.refundOnCreditFail': boolean | undefined;
  'provider.filterExternalProviderBets': boolean | undefined;
  'provider.creditOnDisconnect': boolean | undefined;
  'provider.isInternal': boolean | undefined;
  'provider.rgsId': string | undefined;
  'provider.integrationType': IntegrationEnum | undefined;
  'provider.createdAt': string | undefined;
};

export const defaultProviderListFilter: ProviderListFilter = {
  'provider.id': undefined,
  'provider.configs': undefined,
  'provider.updatedAt': undefined,
  'provider.name': undefined,
  'provider.games': undefined,
  'provider.configId': undefined,
  'provider.apiUrl': undefined,
  'provider.syncRoundEnd': undefined,
  'provider.status': undefined,
  'provider.retryScheduledSendCredit': undefined,
  'provider.refundOnCreditFail': undefined,
  'provider.filterExternalProviderBets': undefined,
  'provider.creditOnDisconnect': undefined,
  'provider.isInternal': undefined,
  'provider.rgsId': undefined,
  'provider.integrationType': undefined,
  'provider.createdAt': undefined,
};

export const providerListColumnVisibilitySettings = {
  'provider.id': ColumnVisibilityType.Visible,
  'provider.configs': ColumnVisibilityType.Visible,
  'provider.name': ColumnVisibilityType.CanBeHidden,
  'provider.status': ColumnVisibilityType.CanBeHidden,
  'provider.isInternal': ColumnVisibilityType.CanBeHidden,
  'provider.syncRoundEnd': ColumnVisibilityType.CanBeHidden,
  'provider.retryScheduledSendCredit': ColumnVisibilityType.CanBeHidden,
  'provider.refundOnCreditFail': ColumnVisibilityType.CanBeHidden,
  'provider.filterExternalProviderBets': ColumnVisibilityType.CanBeHidden,
  'provider.creditOnDisconnect': ColumnVisibilityType.CanBeHidden,
  'provider.games': ColumnVisibilityType.CanBeHidden,
  'provider.integrationType': ColumnVisibilityType.CanBeHidden,
  'provider.createdAt': ColumnVisibilityType.CanBeHidden,
  'provider.configId': ColumnVisibilityType.CanBeVisible,
  'provider.rgsId': ColumnVisibilityType.CanBeVisible,
  'provider.apiUrl': ColumnVisibilityType.CanBeVisible,
  'provider.updatedAt': ColumnVisibilityType.CanBeVisible,
} satisfies ColumnVisibilitySettings<ProviderListColumns>;

export const defaultProviderListColumnVisibility = defaultColumnVisibilityParams(
  providerListColumnVisibilitySettings
);

export const providerListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  providerListColumns,
  providerListColumnVisibilitySettings
);
